<template>
  <div class="body1">
    <div class="content">
        <p class="tit-p">COMPANY INTRODUCTION</p>
        <p class="des-p">Established in 2008,ELE EDUCATION is the English education brand of ELI FUTURE EDUCATION PTE. LTD,a global English program for EFL children aged 3-12.</p>
        <p class="des-p">Improve listening, speaking, reading and writing skills, with focus on the improvement of English application skills for different ages.and emphasis on the development of children’ creative thinking, logical thinking, self-learning ability, critical thinking, leadership and communication skills. It has opened more than 400 learning centers in China,Vietnam and Thailand.</p>
        <p class="des-p">Over the past 20 years, our unique E-Blocks Teaching Program is widely used in more than 17,000 schools, spanning 40 countries, which was developed by more than 200 experts by POSITIVO.</p>
        <p class="des-p">ELE has integrated many prominent educationists philosophy and theory to create a holistic education program.</p>
        <p class="des-p">In ELE, we strive to cultivate enthusiastic, creative learners and critical thinkers from a holistic approach that does not only focus on academic intelligence, but also their emotional intelligence.</p>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped lang="less">
@import "../../assets/style/index";
.body1{
  height: 1230px;
  padding-top: 490px;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  background: url("../../assets/about-us-banner.png") no-repeat top center;
  background-size: 100% auto;
  .content{
    .media-content;
    height: 630px;
    background: #fff;
    border-radius: 25px;
    box-sizing: border-box;
    padding: 48px 80px 34px;
    .tit-p{
      width: 100%;
      text-align: center;
      color: #000;
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .des-p{
      width: 100%;
      font-size: 18px;
      text-align: left;
      line-height: 32px;
      color: #2F2F2F;
      margin-top: 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/about-us/e-body1.vue